import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { FiPlus, FiSearch, FiEdit2, FiTrash2 } from "react-icons/fi";
import { getSheduleList } from "../../redux/services/Shedule Services/Shedule.Services";
import { activeLeadType, rowsForVendorList, leadTypeLabel, isSplitLeadVendor, formatVisitDay } from "../../Utils/role";

function Shedulelist() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const leadType = activeLeadType(searchParams.get("lead_type"));
  const typeLabel = leadTypeLabel(leadType);
  const officeVisitsOnly = isSplitLeadVendor();

  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [meetingType, setMeetingType] = useState("");

  const fetchMeetings = async () => {
    try {
      setLoading(true);
      const res = await getSheduleList(leadType ? { lead_type: leadType } : {});

      // ✅ API returns: { success, message, data: { status, vendor_id, total, visits: [...] } }
      const list =
        res?.data?.data?.visits ||   // primary path from your sample response
        res?.data?.visits ||
        res?.visits ||
        [];

      const visits = Array.isArray(list) ? list : [];
      setMeetings(rowsForVendorList(visits, leadType));
    } catch (err) {
      console.log("visit list error:", err);
      setMeetings([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadType]);

  // ✅ Client-side search + status + type filter (mapped to API field names)
  const filteredMeetings = meetings.filter((m) => {
    const q = search.toLowerCase();

    const matchesSearch =
      !q ||
      (m.name || "").toLowerCase().includes(q) ||
      (m.phone || "").toLowerCase().includes(q) ||
      (m.project || "").toLowerCase().includes(q) ||
      (m.lead_id || "").toLowerCase().includes(q);

    const matchesStatus =
      !status || (m.visit_status || "").toLowerCase() === status.toLowerCase();

    // NOTE: API has no "type" field. If you add one later, this will work.
    const matchesType =
      !meetingType ||
      (m.type || m.meeting_type || "").toLowerCase() === meetingType.toLowerCase();

    return matchesSearch && matchesStatus && matchesType;
  });

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>{typeLabel ? `${typeLabel} Schedule` : "Schedule List"}</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>{typeLabel ? `${typeLabel} Schedule` : "Schedule List"}</span>
          </nav>
        </div>

        {/* <div className="page-title fw-semibold fs-18 mb-0">
          <Link to="/add-meeting" className="add-btn">
            <FiPlus className="me-2" />
            Add Meeting
          </Link>
        </div> */}
      </div>

      <div className="main_page">
      
            {/* Search Section */}
            <div className="row mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control custumform"
                  placeholder="Search by name, phone, project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <select
                  className="form-control custumform"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">All Status</option>
                  {officeVisitsOnly ? (
                    <>
                      <option value="scheduled">Visit booked</option>
                      <option value="rescheduled">Rescheduled</option>
                    </>
                  ) : (
                    <option value="scheduled">Scheduled</option>
                  )}
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>

              {!officeVisitsOnly && (
              <div className="col-md-3">
                <select
                  className="form-control custumform"
                  value={meetingType}
                  onChange={(e) => setMeetingType(e.target.value)}
                >
                  <option value="">All Meeting Type</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="video call">Video Call</option>
                  <option value="phone call">Phone Call</option>
                </select>
              </div>
              )}

              <div className="col-md-2">
                <button
                  className="total_btn lead-btn btn-import w-100"
                  onClick={fetchMeetings}
                >
                  <FiSearch className="me-2" />
                  Search
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Lead Name</th>
                      <th>Phone</th>
                      <th>Project</th>
                      <th>Visit Date</th>
                      <th>Weekday</th>
                      <th>Visit Time</th>
                      <th>Follow-up</th>
                      <th>Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="10" className="text-center py-4">
                          Loading...
                        </td>
                      </tr>
                    ) : filteredMeetings.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center py-4">
                          No visits found
                        </td>
                      </tr>
                    ) : (
                      filteredMeetings.map((m, index) => {
                        // ✅ Correct field mapping from API
                        const id = m.lead_id ?? m.id ?? index + 1;
                        const name = m.name ?? "-";
                        const phone = m.phone ?? "-";
                        const project = m.project || "-";
                        const visitDate = officeVisitsOnly
                          ? (formatVisitDay(m.visit_date) || "-")
                          : (m.visit_date ?? "-");
                        const weekday = m.weekday ?? "-";
                        const visitTime = m.visit_time ?? "-";
                        const statusVal = (m.visit_status ?? "").toLowerCase();
                        const followup = officeVisitsOnly
                          ? formatOfficeFollowUp(m)
                          : (m.followup_on
                            ? `${m.followup_on} (${m.followup_kind ?? "-"})`
                            : "-");
                        const statusText = officeVisitsOnly
                          ? formatOfficeVisitStatus(statusVal)
                          : (m.visit_status ?? "-");

                        const statusBadge =
                          statusVal === "completed"
                            ? "bg-success"
                            : statusVal === "cancelled"
                            ? "bg-danger"
                            : statusVal === "missed"
                            ? "bg-secondary"
                            : "bg-warning text-dark";

                        return (
                          <tr key={id}>
                            <td>{index + 1}</td>
                            <td>{name}</td>
                            <td>{phone}</td>
                            <td>{project}</td>
                            <td>{visitDate}</td>
                            <td>{weekday}</td>
                            <td>{visitTime}</td>
                            <td>{followup}</td>
                            <td>
                              <span className={`badge ${statusBadge}`}>
                                {statusText}
                              </span>
                            </td>
                            <td className="text-center">
                              <div className="d-flex gap-2 justify-content-center">
                                <button
                                  onClick={() =>
                                    navigate(`/edit-meeting/${id}`, { state: m })
                                  }
                                  className="st-action-btn st-view-btn"
                                  title="Edit"
                                >
                                  <FiEdit2 />
                                </button>
                                <button
                                  className="st-action-btn st-delete-btn"
                                  title="Delete"
                                >
                                  <FiTrash2 />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
   
  );
}

function formatOfficeVisitStatus(status) {
  if (status === "rescheduled") return "Rescheduled";
  if (status === "completed") return "Completed";
  if (status === "cancelled") return "Cancelled";
  if (status === "scheduled" || status === "booked") return "Visit booked";
  return status ? "Visit booked" : "-";
}

function formatOfficeFollowUp(visit) {
  const status = String(visit?.visit_status || "").toLowerCase();
  const kind = String(visit?.followup_kind || "").toLowerCase();
  if (status === "rescheduled" || kind === "missed" || kind === "rescheduled") {
    return "Rescheduled";
  }
  if (visit?.followup_on) return `Reminder ${formatVisitDay(visit.followup_on)}`;
  return "-";
}

export default Shedulelist;